import { CategoriesActions } from './action-creators';
import * as actions from './actions';
import { CategoriesState } from './state';
import { categoriesInitialState } from './initial-state';

export const categoriesReducer = (
  state: CategoriesState = categoriesInitialState,
  action: CategoriesActions
): CategoriesState => {
  switch (action.type) {
    case actions.LIST_CATEGORIES_SUCCESS:
      return {
        ...state,
        lists: {
          ...state.lists,
          [action.contentType]:
            action.contentType === 'platform'
              ? action.categories.sort((a, b) => {
                  return a.name.localeCompare(b.name);
                })
              : action.categories,
        },
      };

    case actions.LIST_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.countries,
      };

    case actions.SEARCH_CATEGORIES:
      return {
        ...state,
        results: {
          ...state.results,
          [action.contentType]: [],
        },
      };

    case actions.SEARCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        results: {
          ...state.lists,
          [action.contentType]: action.categories,
        },
      };
    default:
      return state;
  }
};
